import React from 'react';
import ItemCard from '../ItemCard/ItemCard';
import Track from '../Track';
import Text from '../../i18n/Text';

const ItemList = ({ items }) => (
  items.map(({
    image, title, description, url, icon, titleKey, descriptionKey,
  }, index) => (
    <div className="column is-4" key={title}>
      <Track name="splashPage.selectTile" bbTrackActionInfo={title}>
        <ItemCard
          image={image}
          title={titleKey ? <Text>{ titleKey }</Text> : title}
          description={descriptionKey ? <Text>{ descriptionKey }</Text> : description}
          url={url}
          icon={icon}
          qaId={`item-${index}`}
          external
        />
      </Track>
    </div>
  ))
);


export default ItemList;
